const color = {
 blue : "#1976D2",
 blue_selected : "#E3F2FD",
  gris_bg :"#2B3648",
  gris_co : "#212936",
  gris_text : "#56657F",
  gris_title: "#AFBDD1",
  gris_hover :"#DCDCDC",
};

export default color;
